import { forwardRef, useState } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with a built-in eye-icon toggle. Drop-in for shadcn <Input/>
 * — pass any standard input props plus `data-testid` for tests.
 */
const PasswordInput = forwardRef(function PasswordInput({ className = "", testIdSuffix = "password", ...props }, ref) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input
        ref={ref}
        type={show ? "text" : "password"}
        autoComplete={props.autoComplete || "current-password"}
        className={`pr-12 ${className}`}
        {...props}
      />
      <button
        type="button"
        onClick={() => setShow((v) => !v)}
        aria-label={show ? "Hide password" : "Show password"}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-inkmid hover:text-coral p-1 rounded-full transition-colors"
        data-testid={`toggle-${testIdSuffix}-visibility`}
        tabIndex={-1}
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
});

export default PasswordInput;
